import React, { ReactElement, ReactNode } from 'react';
import { getLabel, type SelectItemType } from './Option';

export interface DefaultSelectRenderProps {
  options: readonly SelectItemType[];
  selected: readonly SelectItemType[];
}

export function DefaultSelectRender({
  selected,
}: Readonly<DefaultSelectRenderProps>): ReactElement<DefaultSelectRenderProps> {
  return (
    <>
      {(Array.isArray(selected) ? selected : [selected])
        .map(getLabel)
        .reduce<ReactNode[] | null>((acc, option) => (acc == null ? [option] : [...acc, ', ', option]), null)}
    </>
  );
}
